import React from 'react'

import { ApolloErrorModalProvider, PromptPortalProvider } from '@acorns/web-utils'
import { compose } from 'recompose'
import { ThemeProvider } from 'styled-components'

import { ErrorBoundary } from 'components/ErrorBoundary'
import { ApolloErrorHandlingProvider, ApolloProvider } from 'utils/Apollo'
import { BackendProvider } from 'utils/backend'
import Environment, { EnvironmentProvider } from 'utils/environment'
import { Provider as PromptProvider } from 'utils/prompts'

import Router from './router'
import { withLogVersion } from './utils/with-log-version'
import { SessionProvider } from './providers/SessionProvider'
import { PlaidLayerProvider } from './providers/PlaidLayerProvider/index'
import { UserDataProvider } from './providers/UserProvider'
import { AcornsHelloRemoteStringsProvider } from './providers/AcornsHelloRemoteStringsProvider'
import { AcornsEarlyProvider } from './providers/AcornsEarlyProvider'
import { ResumeFlowProvider } from './providers/ResumeFlowProvider'

type OuterProps = {
  appId: string
  backend: any
  environment: Environment
  theme: any
}

type Props = OuterProps

const enhance = compose<Props, OuterProps>(withLogVersion)

const Application: React.FC<Props> = ({ appId, backend, environment, theme }) => {
  return (
    <EnvironmentProvider env={environment}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <ApolloErrorHandlingProvider>
            <ApolloErrorModalProvider>
              <ApolloProvider>
                <ResumeFlowProvider>
                  <SessionProvider>
                    <BackendProvider backend={backend} appId={appId}>
                      <AcornsEarlyProvider>
                        <UserDataProvider>
                          <PlaidLayerProvider>
                            <AcornsHelloRemoteStringsProvider>
                              <PromptPortalProvider>
                                <PromptProvider>
                                  <Router />
                                </PromptProvider>
                              </PromptPortalProvider>
                            </AcornsHelloRemoteStringsProvider>
                          </PlaidLayerProvider>
                        </UserDataProvider>
                      </AcornsEarlyProvider>
                    </BackendProvider>
                  </SessionProvider>
                </ResumeFlowProvider>
              </ApolloProvider>
            </ApolloErrorModalProvider>
          </ApolloErrorHandlingProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </EnvironmentProvider>
  )
}

export default enhance(Application)
